import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const AddIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "AddIcon", ...props, ref: ref, children: _jsx("path", { fill: "currentColor", d: "M15.5,7.5h-7V.5a.5.5,0,0,0-1,0v7H.5a.5.5,0,0,0,0,1h7v7a.5.5,0,0,0,1,0v-7h7a.5.5,0,0,0,0-1Z" }) })));
AddIcon.displayName = "AddIcon";
